import { useContext } from 'react';
import { Button } from '@epam/promo';
import { useUuiContext } from '@epam/uui';
import GenerateReportModal from 'modules/list-opportunities/components/generate-report-modal';
import { OPPORTUNITY_PAGE_SIZE } from 'constants/uiConstants';
import { IOpportunityReportPayload } from 'modules/list-opportunities/models/model';
import { OpportunityFilterContext } from 'modules/list-opportunities/FilterContext';
import { EditorSwitchContext, EventOrganizerSwitchContext } from 'App';

export function OpportunityGenerateReportButton({ disabled = false }) {
  const opportunityFilterValue = useContext(OpportunityFilterContext);
  const svc = useUuiContext();
  const editorSwitch =
    useContext(EditorSwitchContext) || useContext(EventOrganizerSwitchContext);

  const generateReport = () => {
    if (disabled) return;
    const reportParams: IOpportunityReportPayload = {
      offset: {
        amount: OPPORTUNITY_PAGE_SIZE,
        startPoint: (opportunityFilterValue.page - 1) * OPPORTUNITY_PAGE_SIZE,
      },
    };
    if (opportunityFilterValue.searchText != '') {
      reportParams.searchPhrase = opportunityFilterValue.searchText;
    }
    if (opportunityFilterValue.selectedPositions?.length !== 0) {
      reportParams.positions = opportunityFilterValue.selectedPositions;
    }
    if (opportunityFilterValue.selectedTechnologies?.length !== 0) {
      reportParams.technologies = opportunityFilterValue.selectedTechnologies;
    }
    if (opportunityFilterValue.selectedChallenges?.length !== 0) {
      reportParams.challenges = opportunityFilterValue.selectedChallenges;
    }
    svc.uuiModals.show((modalProps: any) => (
      <GenerateReportModal
        modalProps={modalProps}
        reportParams={reportParams}
      />
    ));
  };

  if (!editorSwitch) return null;

  return (
    <Button
      size="36"
      color="blue"
      caption="Generate Report"
      fill="white"
      onClick={generateReport}
      isDisabled={disabled}
    />
  );
}
